import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import DataGrid from './data-grid';
import __JSONbigFactory from 'json-bigint';
var JSONbigString = __JSONbigFactory({
  storeAsString: true
});
export default class ResearchAssistantGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'instruction',
      title: 'Query',
      cell: props => {
        var row = props.dataItem;
        var id = JSONbigString.parse(row.id);
        var detailLink = '/Research/Assistant/Detail/' + id;
        var query = row.instruction;
        var status = row.status;
        if (!status) {
          detailLink = '/Research/Assistant';
        }
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis-3",
          title: query
        }, /*#__PURE__*/React.createElement(Link, {
          to: detailLink
        }, query)));
      }
    }, {
      field: 'createdDate',
      title: 'Created Date',
      cell: props => {
        var row = props.dataItem;
        var createdDate = moment(row.createdDate).format('ll');
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, createdDate));
      }
    }, {
      field: 'status',
      title: 'Status',
      cell: props => {
        var row = props.dataItem;
        var status = row.status;
        if (!status) {
          status = 'Processing';
        } else {
          status = 'Complete';
        }
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, status));
      }
    }, {
      title: '',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-button margin-right two hide",
          onClick: event => this.props.onExportItem(event, row)
        }, "Export"), /*#__PURE__*/React.createElement("div", {
          className: "text-button",
          onClick: event => this.props.onDeleteItem(event, row)
        }, "Delete")));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}